var map = {
	"./flag_at.svg": 2424,
	"./flag_az.svg": 2622,
	"./flag_be.svg": 3808,
	"./flag_br.svg": 1727,
	"./flag_by.svg": 6100,
	"./flag_ca.svg": 4499,
	"./flag_ch.svg": 9994,
	"./flag_cn.svg": 7460,
	"./flag_cs.svg": 5729,
	"./flag_cz.svg": 8600,
	"./flag_de.svg": 5246,
	"./flag_dk.svg": 2376,
	"./flag_ee.svg": 2925,
	"./flag_es.svg": 2547,
	"./flag_fi.svg": 8576,
	"./flag_fr.svg": 4587,
	"./flag_gr.svg": 9436,
	"./flag_hr.svg": 2247,
	"./flag_hu.svg": 8962,
	"./flag_ie.svg": 8481,
	"./flag_is.svg": 1647,
	"./flag_it.svg": 7856,
	"./flag_jp.svg": 1957,
	"./flag_lt.svg": 1895,
	"./flag_lu.svg": 2358,
	"./flag_me.svg": 9941,
	"./flag_mk.svg": 467,
	"./flag_nl.svg": 6693,
	"./flag_no.svg": 5446,
	"./flag_pl.svg": 8883,
	"./flag_pt.svg": 8920,
	"./flag_ro.svg": 714,
	"./flag_rs.svg": 7774,
	"./flag_ru.svg": 2688,
	"./flag_se.svg": 8127,
	"./flag_si.svg": 427,
	"./flag_sk.svg": 745,
	"./flag_sr.svg": 4416,
	"./flag_tr.svg": 993,
	"./flag_ua.svg": 113
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8369;